import { Button } from "@mui/material"

export const coinPackColumn=[
  {
    id: "S.No",
    label: "S.No",
    minWidth: 70,
    align: "left",
  },
  {
    id: "name",
    label: "Name",
    minWidth: 70,
    align: "center",
  },
  {
    id: "description",
    label: "Description",
    minWidth: 70,
    align: "center",
  },
  {
    id: "coins",
    label: "Coins",
    minWidth: 70,
    align: "center",
  },
  {
    id: "image",
    label: "Image",
    type:"IMAGE",
    minWidth: 70,
    align: "center",
  },
  {
    id: "price",
    label: "Price",
    minWidth: 70,
    align: "center",
  },
  {
    id: "active",
    label: "Active",
    minWidth: 70,
    align: "center",
  },

  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center",
  },
]
export const coinPackFormFields = [
  {
    name: "name",
    label: "name",
    type: "text",
    required: true,
  },
  {
    name: "description",
    label: "description",
    type: "description",
    required: true,
  },
  {
    name: "coins",
    label: "coins",
    type: "number",
    required: true,
  },
  {
    name: "image",
    label: "image",
    type: "file",
    required: true,
  },
  // {
  //   name: "price.rate",
  //   label: "price",
  //   type: "number",
  //   required: true,
  // },
  
]